<div class="top-header">
  <div class="container">
    <span fxFlex></span>
    <a class="p-3 mr-3" routerLink = "/home" routerLinkActive="active-link">Home</a>
    <a class="p-3 mr-3" routerLink = "/contact" routerLinkActive="active-link">Contact</a>
    <a class="p-3 mr-3" routerLink = "/auth/sign-in" routerLinkActive="active-link">Login</a>
    <a class="p-3 mr-3" routerLink = "/auth/sign-up" routerLinkActive="active-link">Sign up</a>
  </div>
</div>